"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var Message_1 = __importDefault(require("../../../Message"));
var GenericError = function () {
    var formik = (0, formik_1.useFormikContext)();
    var errorMessage = formik.errors['__form'];
    return errorMessage ? react_1.default.createElement(Message_1.default, { type: "error" }, errorMessage) : null;
};
exports.default = GenericError;
